// extracted by mini-css-extract-plugin
export default {"info":"Oke4yjcucG","h-rule":"ZcmCmDvcsX","hRule":"ZcmCmDvcsX","logo":"DUuth4UQ6q","further-resources":"BSMP068YlW","furtherResources":"BSMP068YlW"};